/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_No_KeyInputs */

const en_admin_indexnow_no_key = /** @type {(inputs: Admin_Indexnow_No_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No key saved yet.`)
};

/**
* | output |
* | --- |
* | "No key saved yet." |
*
* @param {Admin_Indexnow_No_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_no_key = /** @type {((inputs?: Admin_Indexnow_No_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_No_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_no_key(inputs)
});
export { admin_indexnow_no_key as "admin.indexnow.no_key" }